import { Container } from 'react-bootstrap';

const BasicContainer = ({ children }) => <Container style={{ marginTop: '80px' }}>{children}</Container>;

export default BasicContainer;
